import React from 'react';
import { LogIn, Check, CreditCard } from 'lucide-react';
import { useAuth } from '../../contexts/AuthContext';

export default function LoginPrompt() {
  const { login } = useAuth();

  return (
    <div className="flex flex-col items-center justify-center space-y-6 p-8 bg-[#111] border border-gray-800 rounded-lg text-center">
      <LogIn className="w-16 h-16 text-[#86868b]" />
      <h2 className="text-2xl font-medium text-[#c8c2bd]">
        Please log in to upload invoices
      </h2>
      <p className="text-[#86868b]">
        You need to be authenticated to use this feature
      </p>
      <button
        onClick={login}
        className="mt-4 px-8 py-3 bg-indigo-600 hover:bg-indigo-700 text-white rounded-lg font-medium transition-colors inline-flex items-center gap-2"
      >
        <LogIn className="w-5 h-5" />
        Signup for free
      </button>

      <ul className="flex flex-col gap-3 text-[#86868b]">
        <li className="flex items-center gap-2">
          <Check className="w-4 h-4 text-green-500" />
          <span>3 free QR invoices per month</span>
        </li>
        <li className="flex items-center gap-2">
          <CreditCard className="w-4 h-4 text-green-500" />
          <span>No credit card required</span>
        </li>
      </ul>
    </div>
  );
}